import {useMatchMedia} from '@pexip/hooks';

import {XL} from '../../constants/mediaQueries';

export const useXl = () => useMatchMedia(XL);
